
var VCA = VCA || {};

VCA.VetsourceBannerModal = (function ($) {

    var ui = {};

    function cacheUI() {
        ui.$VetsourceModalLink = $('.js-vetsource-modal');
    }

    function bindEvents() {
        ui.$VetsourceModalLink.on('click', showAlertModal);
    }

    function showAlertModal() {
        $('#AboutVetsourceModal').modal('show');
    }

    function init() {
        cacheUI();
        bindEvents();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.VetsourceBannerModal.init();
});